var randomColor = require("randomcolor")
var c = {};
c.random = randomColor

export var Colors = c;